module.exports = __webpack_public_path__ + "static/media/landing-img.9b5c3e97.png";